import React from 'react';

import PropTypes from 'prop-types';
import './dialogs.scss';
import IconClose from './../../img/icons/icon_close.svg';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
// const useStyles = makeStyles((theme) => ({
//   Dialog: {
//     // display: 'flex',
//     // alignItems: 'center',
//     // justifyContent: 'center',
//     // overflow: 'scroll',
//     // position: 'absolute',
//     // top: '20%',
//     // left: '20%',
//     // height: '100%',
//     // display: 'block',
//   },
//   paper: {
//     backgroundColor: theme.palette.background.paper,
//     border: '2px solid #000',
//     boxShadow: theme.shadows[5],
//     padding: theme.spacing(2, 4, 3),
//   },
// }));

function DialogDidYouKnow(props) {
  //   const classes = useStyles();
  const { onClose, selectedValue, open } = props;
  const [scroll] = React.useState('body');
  const handleClose = () => {
    onClose(selectedValue);
  };

  //   const handleListItemClick = (value) => {
  //     onClose(value);
  //   };

  return (
    <Dialog
      className="App_modal"
      onClose={handleClose}
      aria-labelledby="modal-title"
      open={open}
      scroll={'body'}
    >
      <DialogTitle id="modal-title" align="center">
        The history of insurance
      </DialogTitle>
      <DialogContent dividers={scroll === 'body'}>
        <span
          className="App_close_icon"
          autoFocus
          onClick={handleClose}
          color="primary"
        >
          <img src={IconClose} alt="close modal" />
        </span>
        <p>
          Sea loans or foenus nauticum were common before the traditional marine
          insurance in the medieval times, in which an investor lent his money
          to a traveling merchant, and the merchant would be liable to pay it
          back if the ship returned safely.
        </p>

        <p>
          In this way, credit and sea insurance were provided at the same time.
          The rate of interest for sea loans was high to compensate for the high
          risks involved.
        </p>

        <p>
          <Button
            className="App-button-b"
            rel="noreferrer"
            target="_blank"
            href="https://en.wikipedia.org/wiki/History_of_insurance#Medieval_era"
          >
            Wikipedia
          </Button>
        </p>
      </DialogContent>
    </Dialog>
  );
}

DialogDidYouKnow.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default function DidYouKnowDialogContent() {
  const [open, setOpen] = React.useState(false);

  const handleClickDidYouKnowOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <DialogDidYouKnow open={open} onClose={handleClose} />
      <Button className="App-button-b" onClick={handleClickDidYouKnowOpen}>
        Read More
      </Button>
    </React.Fragment>
  );
}
